module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseWidget', [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("dashboardModule.planoTitle")))]), _vm._v(" "), _c('template', {
    slot: "content-desktop"
  }, [_c('planoList', {
    key: '2',
    attrs: {
      "listPlano": _vm.planoList
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "content-mobile"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.planoList), function(item) {
    return _c('swiper-slide', {
      key: item.name,
      staticClass: "txtCenter"
    }, [_c('div', {
      staticClass: "swipe-content"
    }, [_c('div', {
      staticClass: "header flexContainer jc-sb"
    }, [_c('div', {
      staticClass: "status uppercase",
      class: _vm.renderStatus(item.status)
    }, [_vm._v(_vm._s(_vm.$t("planoList." + _vm.renderStatus(item.status))))]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer"
    }, [(item.isLocked) ? _c('img', {
      staticClass: "lock",
      attrs: {
        "src": require("../../../assets/lock_mobile.svg"),
        "width": "20",
        "alt": "lock_mobile.svg"
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "src": require("../../../assets/comment_mobile.svg"),
        "width": "20",
        "alt": "lock_mobile.svg"
      },
      on: {
        "click": function($event) {
          _vm.modalComment(item.id);
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "title flexContainer jc-sa"
    }, [_c('div', {
      staticClass: "size2of5"
    }, [_c('img', {
      attrs: {
        "src": require("../../../../static/assets/plano.png"),
        "alt": "plano",
        "width": "37",
        "height": "61"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "txtLeft uppercase size3of5",
      on: {
        "click": function($event) {
          _vm.openPlano(item.id, item.isLocked);
        }
      }
    }, [_c('h1', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(item.campaign.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "infos center txtCenter"
    }, [_c('p', [_c('span', {
      staticClass: "hidden"
    }, [_vm._v("4 High |")]), _vm._v(" " + _vm._s(item.width) + " x " + _vm._s(item.height))]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "ff-bold"
    }, [_vm._v(_vm._s(_vm.$t("planoList.modified")) + ":")]), _vm._v(" " + _vm._s(item.modifiedDate) + "\n                        ")]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "ff-bold lowercase"
    }, [_vm._v(_vm._s(_vm.$t("planoList.by")) + ":")]), _vm._v(" " + _vm._s(item.modifiedUser.firstname) + "\n                            " + _vm._s(item.modifiedUser.lastname) + "\n                        ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [(_vm.hasAccessCreate('plano_builder')) ? _c('router-link', {
    staticClass: "btnCreatPlano btnExp primary-text fright primary-border-color iBlock pointer mobileNot txtCenter",
    attrs: {
      "to": "/template-plano",
      "tag": "span"
    }
  }, [_vm._v(_vm._s(_vm.$t("plano.create")))]) : _vm._e(), _vm._v(" "), _c('LinkButton', {
    attrs: {
      "to": {
        name: 'Planos',
        query: _vm.getLinkParams({
          campaign: _vm.selectedCampaign
        })
      },
      "text": _vm.$t('dashboardModule.seeAllPlanos')
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6fa07d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/PlanoWidget.vue
// module id = 3389
// module chunks = 0